import { render, staticRenderFns } from "./host-news-activity.vue?vue&type=template&id=216c8326&scoped=true&"
import script from "./host-news-activity.vue?vue&type=script&lang=js&"
export * from "./host-news-activity.vue?vue&type=script&lang=js&"
import style0 from "./host-news-activity.vue?vue&type=style&index=0&id=216c8326&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216c8326",
  null
  
)

export default component.exports